<div class="modal-header">
  <h5 class="modal-title" i18n="@@PrepareInvoiceTitle">Rechnung erstellen</h5>
  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="close()"></button>
</div>

<div class="modal-body">
  <div>
    <h5 i18n="@@InvoiceRecipient">Rechnungsempfänger</h5>
    <form [formGroup]="formService.form" (ngSubmit)="onSubmit(formService.form.value)" class="recipient" *ngIf="isFormReady">
      <div class="form-group company">
        <!-- <label for="company">Firma</label> -->
        <input type="text" id="company" formControlName="company" class="form-control" placeholder="Firma" i18n-placeholder="@@Company"/>
      </div>
      <div class="form-group gender">
        <!-- <label for="gender">Firma</label> -->
        <select id="gender" formControlName="gender" class="form-select" placeholder="Anrede" i18n-placeholder="@@Gender">
          <option value="" disabled selected i18n="@@Titleselect">Anrede</option>
          <option value="male" i18n="@@TitleMrOption">Herr</option>
          <option value="female" i18n="@@TitleMrs_MsOption">Frau</option>
          <option value="diverse" i18n="@@TitleDiversOption">Divers</option>
        </select>
      </div>
      <div class="form-group firstname">
        <!-- <label for="firstname">Vorname</label> -->
        <input type="text" id="firstname" formControlName="firstName" class="form-control" placeholder="Vorname*" i18n-placeholder="@@FirstName"/>
      </div>
      <div class="form-group lastname">
        <!-- <label for="lastname">Nachname</label> -->
        <input type="text" id="lastname" formControlName="lastName" class="form-control" placeholder="Nachname*" i18n-placeholder="@@LastName"/>
      </div>
      <div class="form-group street">
        <!-- <label for="street">Straße</label> -->
        <input type="text" id="street" formControlName="street" class="form-control" placeholder="Straße*" i18n-placeholder="@@Street"/>
      </div>
      <div class="form-group housenumber">
        <!-- <label for="houseNumber">Hausnummer</label> -->
        <input type="text" id="houseNumber" formControlName="houseNumber" class="form-control" placeholder="Hausnummer*" i18n-placeholder="@@HouseNumber"/>
      </div>
      <div class="form-group postcode">
        <!-- <label for="postcode">PLZ</label> -->
        <input type="text" id="postcode" formControlName="postcode" class="form-control" placeholder="PLZ*" i18n-placeholder="@@PostCode" maxlength="5" />
      </div>
      <div class="form-group city">
        <!-- <label for="city">Postleitzahl</label> -->
        <input type="text" id="city" formControlName="city" class="form-control" placeholder="Stadt*" i18n-placeholder="@@City"/>
      </div>
      <div class="form-group email">
        <!-- <label for="email">E-Mail</label> -->
        <input type="text" id="email" formControlName="email" class="form-control" placeholder="E-Mail" i18n-placeholder="@@E-Mail"/>
      </div>
    </form>
  </div>

  <div>
    <h5>Ladevorgänge</h5>
    <div *ngIf="!isTableReady" class="loading-spinner-container">
      <div class="spinner-border text-primary loading-spinner-md" role="status">
        <span class="visually-hidden-focusable">Loading...</span>
      </div>
    </div>
    <table class="table" *ngIf="isFormReady && isTableReady">
      <thead>
        <tr>
          <th></th>
          <!-- <th>ID</th> -->
          <th i18n="@@Date">Datum</th>
          <th i18n="@@ChargingAmountInKWh">Lademenge in kWh</th>
          <th i18n="@@PricePerKWh">Preis pro kWh</th>
          <th i18n="@@Price">Betrag</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="invoiceItems.length == 0"><td colspan="6" style="text-align: center;" i18n="@@NoOpenTransactionsWarningText">Dieser Benutzer hat keine offenen Ladevorgänge</td></tr>
        <tr *ngFor="let invoiceItem of invoiceItems" (click)="toggleInvoiceItem(invoiceItem.id)" class="linkTableRow" [ngClass]="{'darker-row': invoiceItem.billingMethod != 'Manual'}"
          [ngbTooltip]="invoiceItem.billingMethod != 'Manual' ? 'Am Monatsende erfolgt die Abrechnung dieses Ladevorgangs automatisch durch das System.' : ''">
          <td><input type="checkbox" [checked]="isChecked(invoiceItem.id)" [disabled]="invoiceItem.billingMethod != 'Manual'" class="form-check-input" /></td>
          <!-- <td>{{ invoiceItem.id }}</td> -->
          <td>{{ parseDate(invoiceItem.startTimestamp) }}</td>
          <td>{{ invoiceItem.quantity | kwh }}</td>
          <td>€ {{ invoiceItem.unitPrice | number: '1.2-2':'de-DE' }}</td>
          <td>€ {{ invoiceItem.total | number: '1.2-2':'de-DE' }}</td>
        </tr>
      </tbody>
      <tfoot *ngIf="invoiceItems.length > 0">
        <tr>
          <td>{{ selectedInvoiceItems.length }}</td>
          <!-- <td>Zeitraum {{ getMonth(selectedTransactions[0].startTimestamp) }}</td> -->
          <td></td>
          <td>{{ getInvoiceMeterAmount() | kwh }}</td>
          <td></td>
          <td>€ {{ getInvoiceAmount() | number: '1.2-2':'de-DE' }}</td>
        </tr>
      </tfoot>
    </table>
  </div>
</div>

<div class="modal-footer" *ngIf="isFormReady">
  <button type="button" class="btn btn-yellow" data-bs-dismiss="modal" (click)="close()"  i18n="@@CancelButton">Abbrechen</button>
  <button type="submit" class="btn btn-yellow" (click)="submit()" [disabled]="selectedInvoiceItems.length < 1 || !formService?.form?.valid" i18n="@@CreateButton">Erstellen</button>
  <button type="submit" class="btn btn-yellow" (click)="submit(true)" [disabled]="selectedInvoiceItems.length < 1 || !formService?.form?.valid" i18n="@@CreateAndDownloadButton" >Erstellen und herunterladen</button>
  <!-- <form [formGroup]="formService.form" (ngSubmit)="prepareInvoiceComponent.onSubmit(formService.form.value)">
  </form> -->
</div>
